import { useRef } from 'react';
import { IRoute } from '../../routes/routes';
import { INavigationItem } from "../../services/navigation-data-service/Models";
import NavigationObjectList from '../navigation/NavigationObjectList';
import BreadCrumbMenu from './BreadCrumbMenu';
import useAutoScroll from '../../hooks/use-auto-scroll/useAutoScroll';

export type BreadCrumbObjectMenuProps = {
    open: boolean;
    anchorEl?: HTMLElement | null;
    placement?: "bottom" | "right";
    offset?: [number, number];

    item: INavigationItem;
    route: IRoute;
    offline: boolean;
    onClick?: (item: INavigationItem, route: IRoute, shiftKey: boolean, ctrlKey: boolean) => void;
    onClose?: () => void;
};

export default function BreadCrumbObjectMenu({
    open,
    anchorEl,
    placement,
    offset,
    item,
    route,
    offline,
    onClick,
    onClose,
}: BreadCrumbObjectMenuProps) {

    const menuRef = useRef<HTMLDivElement>(null);

    useAutoScroll(open, menuRef);

    return (
        <BreadCrumbMenu
            anchorEl={anchorEl}
            open={open}
            placement={placement}
            offset={offset}
            onClose={() => onClose?.()}
            ref={menuRef}
        >
            <NavigationObjectList
                item={item}
                route={route}
                enabled={open}
                offline={offline}
                onClick={onClick}
            />
        </BreadCrumbMenu>
    );
}